<template>

<form
  class="mx-auto col-sm-12"
  @submit.prevent
>
  <b-alert
    :show="alert.show"
    @dismissed='alert.show = false'
    dismissible
    fade
    :variant="alert.type"
  >
    {{ alert.message }}
  </b-alert>

  <div class="row">
    <div class="form-group col-lg-6">
      <label for="serie">{{ $t('serie') }}</label>
      <input
        type="text"
        id="serie"
        name="serie"
        class="form-control"
        :placeholder="$t('ph_serie')"
        v-model="serial"
        v-validate="`required`"
      />
    </div>

    <div class="form-group col-lg-6" :class="{ 'has-error': errors.has('board') }">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      />

      <small v-show="errors.has('board')" class="form-text text-muted">
        {{ errors.first('board') }}
      </small>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4">
      <LoaderButton
        @click="getVehicleAndLastCommands"
      >
        {{ $t('search') }}
      </LoaderButton>
    </div>
  </div>

  <div class="row" v-show="lastPosition.length > 0">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="lastPosition"
        :fields='fieldsLastPosition'
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col">
      <label for="command">{{ $t('command') }}</label>
      <Combobox
        class="bg-white"
        name='command'
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('command')"
        :options="commands"
        :initial-value="command"
        label="name"
        v-model="command"
        :reduce="command => command.id"
        v-validate="'required'"
      />
      <small v-show="errors.has('command')" class="form-text text-muted">
        {{ errors.first('command') }}
      </small>
    </div>
  </div>

  <div class="row" v-show="command == 6">
    <div class="form-group col">
      <label for="odometer">{{ $t('odometer') }}</label>
      <CurrencyInput
        id='odometer'
        name='odometer'
        v-model="odometer"
        :currency='null'
        :precision=1
        :placeholder="$t('ph_odometer')"
        :auto-decimal-mode="true"
        class=" form-control"
        locale='pt-BR'
      />
    </div>
  </div>

  <div class="row" v-show="command == 8">
    <div class="form-group col">
      <label for="free_text">{{ $t('free_text') }}</label>
      <textarea
        type="text"
        name="free_text"
        class="form-control"
        :placeholder="$t('ph_free_text')"
        v-model="freeText"
      />
    </div>
  </div>

  <div class="row" v-show="command == 9">
    <div class="form-group col">
      <label for="free_text_batch">{{ $t('free_text_batch') }}</label>
      <textarea
        type="text"
        name="free_text_batch"
        class="form-control"
        :placeholder="$t('ph_free_text_batch')"
        v-model="freeTextBatch"
        rows="6"
      />
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" v-for="(input, index) in inputs" :key="index">
      <label :for="input">{{ input }}</label>
      <input
        type="text"
        :id="input"
        :name="input"
        class="form-control"
        v-model="templateVars[input]"
        @input="changeFinalString"
      />
    </div>
  </div>

  <div class="row" v-show="command == 8 && this.freeTextFinal">
    <div class="form-group col">
      <label for="command">{{ $t('command') }}</label>
      <textarea
        type="text"
        name="command"
        disabled
        class="form-control"
        v-model="freeTextFinal"
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4">
      <LoaderButton
        @click="sendCommand"
      >
        {{ $t('send_command') }}
      </LoaderButton>
    </div>
  </div>

  <div class="row" v-show="lastCommands.length > 0">
    <div class="col-12">
    <h3>Últimos comandos enviados</h3>
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="lastCommands"
        :fields='fieldsLastCommands'
      >
        <template v-slot:cell(ID_CMD)={item}>
          <div class="text-center">
            <b-button
              v-if="item.status === 0 || item.status === 2 || item.status === 3 || item.status === 10"
              size="sm"
              variant='danger'
              pill
              @click="cancelCommand(item.ID_CMD)"
            >
              <i class="fas fa-ban" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>

  <!-- MODAL ERRORS -->
  <div
    ref='modalErrors'
    id="modalErrors"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalErrors"
    aria-hidden="true"
  >
    <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalErrorsLabel">Comandos com erro</h5>
        </div>

        <div class="modal-body">
          <ul>
            <li v-for="(item, index) in commandsError" :key="index">
              {{ item.text }}
            </li>
          </ul>
        </div>

        <div class="modal-footer">
          <b-button
            class="mt-3"
            id='closeModal'
            data-dismiss="modal"
          >
            {{ $t('close') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</form>

</template>

<script>
import { mapState } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import commands from '@/config/commands'
import { request } from '@/lib/http'
import moment from 'moment-timezone'
import os from 'os'

export default {
  name: 'SendCommandForm',

  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      serial       : '',
      board        : '',
      command      : undefined,
      odometer     : undefined,
      freeText     : '',
      freeTextFinal: '',
      lastPosition : [],
      lastCommands : [],
      vehicle      : [],
      commands,
      fieldsLastCommands: [
        {
          key: 'commandType',
          label: this.$t('command'),
          formatter: (value, key, item) => {
            return item.description
              ? value + ' - ' + item.description
              : value
          }
        },
        { key: 'attemptsMade', label: this.$t('attemptsMade') },
        {
          key: 'status',
          label: this.$t('status'),
          formatter: (value, key, item) => {
            const statusText = item.statusText ? item.statusText : ''
            return value + ' - ' + statusText
          }
        },
        {
          key: 'createAt',
          label: this.$t('createdAt'),
          formatter: (value, key, item) => {
            return moment.parseZone(value).format('DD/MM/YYYY HH:mm:ss')
          }
        },
        {
          key: 'updatedAt',
          label: this.$t('updatedAt'),
          formatter: (value, key, item) => {
            return value
              ? moment.parseZone(value).format('DD/MM/YYYY HH:mm:ss')
              : '-'
          }
        },
        {
          key: 'ID_CMD',
          label: ''
        }
      ],
      fieldsLastPosition: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').add(3, 'h').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'serial',
          label: this.$t('serial')
        },
        {
          key: 'board',
          label: this.$t('board')
        },
        {
          key: 'ignition',
          label: this.$t('ignition'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'speed',
          label: this.$t('speed')
        },
        {
          key: 'odometer',
          label: this.$t('odometer')
        },
        {
          key: 'gprs',
          label: 'GPRS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'gps',
          label: 'GPS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'panic',
          label: this.$t('panic'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'out1',
          label: this.$t('outs_1/2'),
          formatter: (value, key, item) => {
            const out1 = value ? 'SIM' : 'NÃO'
            const out2 = item.out2 ? 'SIM' : 'NÃO'

            return out1 + '/' + out2
          }
        },
        {
          key: 'voltage',
          label: this.$t('voltage'),
          formatter: (value, key, item) => {
            return value + 'V'
          }
        },
        {
          key: 'latitude',
          label: this.$t('lat/lon'),
          formatter: (value, key, item) => {
            return value
              ? value + '/' + item.longitude
              : ''
          }
        },
        {
          key: 'in1',
          label: this.$t('in_1/2/3'),
          formatter: (value, key, item) => {
            const in1 = value ? 'SIM' : 'NÃO'
            const in2 = item.in2 ? 'SIM' : 'NÃO'
            const in3 = item.in3 ? 'SIM' : 'NÃO'

            return in1 + '/' + in2 + '/' + in3
          }
        }
      ],
      alert: {
        show   : false,
        type   : '',
        message: ''
      },
      templateVars : {},
      inputs       : [],
      freeTextBatch: '',
      commandsError: []
    }
  },

  watch: {
    board: function(value) {
      this.command = undefined

      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (this.board.length === 3){
        this.board = value + '-'
      }

      if (this.board.length === 4 && !this.board.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    },

    serial(value) {
      this.command = undefined
    },

    commandHistoric: function(value) {
      this.lastCommands = value.rows || []
    },

    command: function(value) {
      this.odometer = undefined
      this.freeText = ''
    },

    alert: function(value) {
      setTimeout(() => this.alert.show = false, 5000)
    },

    freeText: function(value) {
      if (!value) {
        this.inputs        = []
        this.freeTextFinal = ''
        this.templateVars  = {}

        return
      }

      const regex = /<%=([^>]+)%>/g

      const varItems = value.match(regex)

      if (Boolean(varItems)) {
        for (const item of varItems) {
          const varName = item.replace(/[<%=>]/g, '')

          if (varName !== 'lastInsertId' && !this.inputs.includes(varName)) {
            this.inputs.push(varName)
          }
        }
      }

      const tagsToRemove = []
      for (const input of this.inputs) {
        const wordTag = `<%=${input}%>`

        if (!value.includes(wordTag)) {
          tagsToRemove.push(input)
        }
      }
      for (const remove of tagsToRemove) {
        this.inputs.splice(this.inputs.indexOf(remove), 1)
      }

      let text = value

      const tags = [
        { tag: '<%=deviceId%>', newValue: this.lastPosition[0].serial, key: 'deviceId' },
        { tag: '<%=sendLimit%>', newValue: moment().add(5, 'days').format('YYYY-MM-DD HH:mm:ss'), key: 'sendLimit' },
        { tag: '<%=protocol%>', newValue: this.vehicle[0].protocol, key: 'protocol' }
      ]

      for (const { tag, newValue, key } of tags) {
        if (text.includes(tag)) {
          text = text.replace(tag, newValue)

          const hasKey = this.templateVars.hasOwnProperty(key)

          if (!hasKey) {
            this.templateVars[key] = newValue
          }
        }
      }

      this.changeFinalString()
    }
  },

  computed: {
    ...mapState({
      commandHistoric: state => state.ostests.commandHistoric
    })
  },

  methods: {
    showAlert(type, message) {
      return this.alert = {
        show: true,
        type,
        message
      }
    },

    async getVehicleAndLastCommands() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      try {
        this.vehicle = await request({
          url   : `consult-vehicle`,
          method: 'get',
          params: {
            serial: this.serial,
            board : this.board
          }
        })

        const lastPositions = await request({
          url   : 'last-positions',
          method: 'get',
          params: { vehicleId: this.vehicle[0].VEI_ID }
        })

        if (lastPositions.length > 0) {
          lastPositions[0].serial = this.vehicle[0].EQP_SRN
          lastPositions[0].board  = this.vehicle[0].VEI_PLC

          this.lastPosition = [lastPositions[0]]
        } else {
          this.lastPosition = []
        }

        await dispatch('ostests/fetchCommandHistoric', {
          serial         : this.vehicle[0].EQP_SRN,
          vehicleId      : this.vehicle[0].VEI_ID,
          viewSendCommand: true
        })
      } catch (error) {
        dispatch('overlay/show', false)
        return this.showAlert('danger', error.message)
      }

      dispatch('overlay/show', false)
    },

    async sendCommand() {
      if (!this.command) {
        return this.showAlert('danger', 'Selecione o comando')
      }
      if ((this.command === 8 && this.freeText === '') || (this.command === 9 && this.freeTextBatch === '')) {
        return this.showAlert('danger', 'É necessário informar o texto')
      }
      if (this.command === 6 && !this.odometer) {
        return this.showAlert('danger', 'É necessário informar o odômetro')
      }

      if (this.command === 9) {
        try {
          this.$store.dispatch('overlay/show', true)

          const errors = []

          const commandsToSend = this.freeTextBatch.split(os.EOL).filter(Boolean)

          const hasVersion = this.templateVars.hasOwnProperty('version')

          if (!hasVersion) {
            this.templateVars['version'] = this.vehicle[0].version
          }

          const baseData = {
            id_tipo_comando_veiculo: 8,
            vehicleId: this.vehicle[0].VEI_ID,
            handleGateway: false
          }

          for (const commandToSend of commandsToSend) {
            if (commandToSend) {
              const finalData = {
                ...baseData,
                text: commandToSend.replace(
                  '<%=deviceId%>',
                  commandToSend.includes('ST300')
                    ? String(this.lastPosition[0].serial).padStart(9, '0')
                    : this.lastPosition[0].serial
                ),
                templateVars: this.templateVars
              }

              try {
                await request({
                  method: 'post',
                  url: 'send-command',
                  data: { ...finalData }
                })
              } catch (error) {
                errors.push(finalData)
              }
            }
          }

          this.commandsError = errors

          return errors.length
            ? $('#modalErrors').modal('show')
            : this.showAlert('success', 'Comandos enviados!')
        } catch (error) {
          console.log('[ERROR-SEND-COMMAND] => ', error)
        } finally {
          this.$store.dispatch('overlay/show', false)
        }

        return
      }

      try {
        let data = {
          id_tipo_comando_veiculo: this.command,
          vehicleId: this.vehicle[0].VEI_ID
        }

        if (this.command === 8) {
          const hasVersion = this.templateVars.hasOwnProperty('version')

          if (!hasVersion) {
            this.templateVars['version'] = this.vehicle[0].version
          }

          data.text = this.freeTextFinal
          data.templateVars = this.templateVars
        }

        if (this.command === 6) {
          data.odometer = this.odometer
        }

        await request({
          method: 'post',
          url: `send-command`,
          data
        })

        return this.showAlert('success', 'Comando enviado!')
      } catch (error) {
        return this.showAlert('danger', error.message)
      }
    },

    changeFinalString() {
      let text = this.freeText

      for (const [key, value] of Object.entries(this.templateVars)) {
        text = text.replace(`<%=${key}%>`, value)
      }

      this.freeTextFinal = text
    },

    async cancelCommand(command) {
      try {
        const [{ VEI_ID, EQP_SRN }] = this.vehicle

        await this.$store.dispatch('ostests/cancelCommand', {
          command,
          vehicleId       : VEI_ID,
          equipment       : EQP_SRN,
          viewSendCommands: true
        })

        await this.getVehicleAndLastCommands()

        return this.showAlert('success', 'Enviado cancelamento de comando!')
      } catch (error) {
        return this.showAlert('danger', 'Erro ao enviar comando =>' + error)
      }
    }
  },

  destroyed () {
    this.$store.dispatch('ostests/cleanState')
  },
}
</script>
